import { AxiosError } from "axios";
import { ZodSchema, z } from "zod";

export const isAxiosExpectedError = <Schema extends ZodSchema>(
  error: unknown,
  Schema: Schema,
): error is AxiosError<z.infer<Schema>> & {
  response: NonNullable<AxiosError["response"]>;
} => {
  if (error instanceof AxiosError && error.response) {
    const isValidZodError = Schema.safeParse(error.response.data).success;
    return isValidZodError;
  }

  return false;
};
